import { useLocation } from 'react-router';

/**
 * Хук для определения, нужно ли отображать webim
 * @returns true, если нужно скрыть на странице
 */
export const useIsChatHidden = (): boolean => {
  const hiddenPages = ['dashboard'];

  const location = useLocation();

  const isHidden = hiddenPages.some((page) => location.pathname.endsWith(page));

  return isHidden;
};
